export default __webpack_public_path__ + "static/media/papelitos.4ba1bd24.svg";